"use strict";

var _classCallCheck = require("D:\\Dropbox\\projects\\justinireland.com\\justinirelandcom-cra\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("D:\\Dropbox\\projects\\justinireland.com\\justinirelandcom-cra\\node_modules\\@babel\\runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("D:\\Dropbox\\projects\\justinireland.com\\justinirelandcom-cra\\node_modules\\@babel\\runtime/helpers/getPrototypeOf");

var _inherits = require("D:\\Dropbox\\projects\\justinireland.com\\justinirelandcom-cra\\node_modules\\@babel\\runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SplitFactor = void 0;

var ValueWithRandom_1 = require("../../ValueWithRandom");

var SplitFactor =
/*#__PURE__*/
function (_ValueWithRandom_1$Va) {
  _inherits(SplitFactor, _ValueWithRandom_1$Va);

  function SplitFactor() {
    var _this;

    _classCallCheck(this, SplitFactor);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SplitFactor).call(this));
    _this.value = 3;
    return _this;
  }

  return SplitFactor;
}(ValueWithRandom_1.ValueWithRandom);

exports.SplitFactor = SplitFactor;